import React, { useState, useEffect, useRef, useCallback } from 'react'
import { FiEdit3 } from 'react-icons/fi'
import InboxPanel from './InboxPanel'
import EmailLogPanel from './EmailLogPanel'
import ComposeModal from './ComposeModal'

// Admin "Emails" page: received mail, the sent log, and a compose window, all through Resend.
// `onSummary` hands the unread count up to the sidebar.
const EmailsPanel = ({ route, adminFetch, users, onSummary }) => {
  const [tab, setTab] = useState('inbox')
  const [composing, setComposing] = useState(false)
  const [quota, setQuota] = useState(null)
  const [sentVersion, setSentVersion] = useState(0)   // bumped to reload the sent log

  const fetchRef = useRef(adminFetch)
  fetchRef.current = adminFetch

  const loadSummary = useCallback(async () => {
    try {
      const res = await (await fetchRef.current(`${route}/api/admin/inbox/summary`)).json()
      if (res.status !== 200) return
      setQuota(res.quota)
      onSummary?.(res)
    } catch {
      // the counts are only informative
    }
  }, [route]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { loadSummary() }, [loadSummary])

  const afterSend = () => {
    setSentVersion(v => v + 1)
    loadSummary()
  }

  return (
    <>
      <div className="adm-email-head">
        <div className="adm-tabs" role="tablist">
          <button role="tab" aria-selected={tab === 'inbox'} className={tab === 'inbox' ? 'active' : ''} onClick={() => setTab('inbox')}>Inbox</button>
          <button role="tab" aria-selected={tab === 'sent'} className={tab === 'sent' ? 'active' : ''} onClick={() => setTab('sent')}>Sent</button>
        </div>
        <button className="adm-btn primary small" onClick={() => setComposing(true)}><FiEdit3 size={14} /> New email</button>
      </div>

      {tab === 'inbox'
        ? <InboxPanel route={route} adminFetch={adminFetch} onChange={afterSend} />
        : <EmailLogPanel route={route} adminFetch={adminFetch} refreshKey={sentVersion} onChange={loadSummary} />}

      {composing && (
        <ComposeModal
          route={route}
          adminFetch={adminFetch}
          users={users}
          quota={quota}
          onClose={() => setComposing(false)}
          onSent={afterSend}
        />
      )}
    </>
  )
}

export default EmailsPanel
